module.exports = __webpack_public_path__ + "img/img.04b7ee12.png";